var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L0 19H22L11 0ZM11 4L18.53 17H3.47L11 4ZM10 8V12H12V8H10ZM10 14V16H12V14",
    fill: "fillCurrent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotificationIcon);
export default __webpack_public_path__ + "static/media/error-notification-icon.ccc0cb0b.svg";
export { ForwardRef as ReactComponent };